import { restQuery } from 'iomart-hooks';

type DirectUploadResponse = {
  entity: string;
  folder: string;
  files: Array<{ name: string; url: string }>;
};

/** Загрузка фото позиции заявки. Путь: procurement-request/{requestId}/{slotId}, slotId = UUID (соль). */
export const uploadProcurementRequestItemFiles = async (
  requestId: number,
  slotId: string,
  files: File[]
): Promise<string[]> => {
  if (!files.length) return [];
  const formData = new FormData();
  files.forEach((file) => formData.append('file', file, file.name));
  const response = await restQuery.uploads.procurementRequest(requestId)(slotId).post({
    data: formData,
  });
  const payload = response as DirectUploadResponse;
  return (payload.files || []).map((f) => f.url);
};

export const uploadProductFilesById = async (id: number, files: File[]): Promise<string[]> => {
  if (!files.length) {
    return [];
  }
  const formData = new FormData();
  files.forEach((file) => formData.append('file', file, file.name));
  const response = await restQuery.uploads.product(id).post({
    data: formData,
  });
  const payload = response as DirectUploadResponse;
  return (payload.files || []).map((f) => f.url);
};

export const deleteProductFilesById = async (id: number, files: string[]) => {
  if (!files.length) {
    return;
  }
  await restQuery.uploads.product(id).delete.post({
    data: { files },
  });
};

export const uploadCategoryFilesById = async (id: number, files: File[]): Promise<string[]> => {
  if (!files.length) {
    return [];
  }
  const formData = new FormData();
  files.forEach((file) => formData.append('file', file, file.name));
  const response = await restQuery.uploads.category(id).post({
    data: formData,
  });
  const payload = response as DirectUploadResponse;
  return (payload.files || []).map((f) => f.url);
};

export const deleteCategoryFilesById = async (id: number, files: string[]) => {
  if (!files.length) {
    return;
  }
  await restQuery.uploads.category(id).delete.post({
    data: { files },
  });
};
